import React from "react";
import classes from "./Input.module.css";

const Input = props => {
    function isInvalid({valid, touched, shouldValidate}){
        return !valid && shouldValidate && touched
    }
  const inputType = props.type || "text";
  const cls = [classes.Input];
  const htmlFor = `${inputType}-${Math.random()}`;
  if(isInvalid(props)){
      cls.push(classes.invalid)
  }
  return (
    <div className={cls.join(" ")}>
      <label htmlFor={htmlFor}>{props.label}</label>
      <input id={htmlFor} type={inputType} value={props.value} onChange={props.onChange}></input>
      {isInvalid(props) && <span>{props.errorMessage || 'Введите верное значение'}</span>}
    </div>
  );
};

export default Input;
